import React from 'react';
import { FaPhone, FaChevronRight } from 'react-icons/fa';

function Iletisim() {
  return (
    <div className="w-full min-h-[calc(100vh-64px)] bg-white">
      {/* Başlık */}
      <div className="bg-gradient-to-r from-slate-50 to-slate-100 py-12 md:py-16">
        <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
          <h1 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4">İLETİŞİM</h1>
          <div className="w-20 h-1 bg-primary mx-auto"></div>
          <p className="text-gray-600 mt-4">Bize ulaşın ve sorunlarınıza çözüm bulun</p>
        </div>
      </div>

      {/* İçerik */}
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
          {/* Telefon */}
          <div className="bg-white border border-gray-200 rounded-lg p-8 hover:shadow-lg transition-shadow duration-300">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center">
                <svg className="w-6 h-6 text-primary" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.938.727.057.057a10 10 0 1014.976-14.976l-1.079 2.158a1 1 0 00.22 1.148l4.154 3.462a1 1 0 001.142-.22l2.834-2.834A1 1 0 0017 2.071V.5a1 1 0 00-1-1h-2c-6.627 0-12 5.373-12 12z" />
                </svg>
              </div>
              <h2 className="text-2xl font-bold text-gray-900">Telefon</h2>
            </div>
            <div className="space-y-3">
              <a href="tel:905404535345" className="flex items-center justify-between p-4 bg-primary hover:bg-secondary text-white rounded-lg transition-all duration-300 hover:shadow-lg transform hover:scale-105 font-semibold">
                <span className="flex items-center gap-2 flex-1">
                  <FaPhone className="w-5 h-5 flex-shrink-0" />
                  <div>
                    <div className="text-xs opacity-90">İsmail Öztürk</div>
                    <div>0540 453 5345</div>
                  </div>
                </span>
                <FaChevronRight className="w-5 h-5 flex-shrink-0 ml-2" />
              </a>
              <a href="tel:905415353561" className="flex items-center justify-between p-4 bg-primary hover:bg-secondary text-white rounded-lg transition-all duration-300 hover:shadow-lg transform hover:scale-105 font-semibold">
                <span className="flex items-center gap-2 flex-1">
                  <FaPhone className="w-5 h-5 flex-shrink-0" />
                  <div>
                    <div className="text-xs opacity-90">Mustafa Öztürk</div>
                    <div>0541 535 3561</div>
                  </div>
                </span>
                <FaChevronRight className="w-5 h-5 flex-shrink-0 ml-2" />
              </a>
            </div>
            <div className="mt-6 p-4 bg-blue-50 border border-blue-200 rounded-lg">
              <p className="text-sm text-blue-800"><strong>💡 İpucu:</strong> Mobil cihazınızda doğrudan arayabilirsiniz!</p>
            </div>
          </div>

          {/* Adres */}
          <div className="bg-white border border-gray-200 rounded-lg p-8 hover:shadow-lg transition-shadow duration-300">
            <div className="flex items-center gap-4 mb-4">
              <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center">
                <svg className="w-6 h-6 text-primary" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                </svg>
              </div>
              <h2 className="text-2xl font-bold text-gray-900">Adres</h2>
            </div>
            <div className="space-y-4">
              <p className="text-gray-700 text-base leading-relaxed">
                <span className="font-semibold block mb-2">Gaziler Mahallesi</span>
                600. Sokak No:31<br />
                45300 Salihli/Manisa<br />
                Türkiye
              </p>
              <a href="https://maps.google.com/?q=Gaziler+Mahallesi+600+Sokak+31+Salihli+Manisa" target="_blank" rel="noreferrer" className="inline-block mt-4 text-primary hover:text-secondary font-semibold transition-colors duration-300">
                Google Maps'te Aç →
              </a>
            </div>
          </div>
        </div>

        {/* Harita */}
        <div className="rounded-lg overflow-hidden shadow-lg border border-gray-200 h-96">
          <iframe
            width="100%"
            height="100%"
            frameBorder="0"
            style={{ border: 0 }}
            src="https://www.google.com/maps/embed/v1/place?q=ÖZTÜRK%20KERESTE%2C%20Gaziler%2C%20600.%20Sk.%20NO%3A31%2C%2045300%20Salihli%2FManisa&key=AIzaSyAJyea_T0j-3UKrw8ydGTRZbcGDybSg9K4"
            allowFullScreen
            title="Öztürk Kereste Harita"
          >
          </iframe>
        </div>
      </div>
    </div>
  );
}

export default Iletisim;